import { lazy } from "react";

// project imports
import Loadable from "ui-component/Loadable";
import MinimalLayout from "layout/MinimalLayout";

// login option 3 routing (JWT - the one we actually use)
const AuthLogin3 = Loadable(
  lazy(() => import("views/pages/authentication/Login")),
);
const AuthRegister3 = Loadable(
  lazy(() => import("views/pages/authentication/Register")),
);
const AuthForgotPassword3 = Loadable(
  lazy(() => import("views/pages/authentication/ForgotPassword")),
);
const AuthCheckMail3 = Loadable(
  lazy(() => import("views/pages/authentication/CheckMail")),
);
const AuthResetPassword3 = Loadable(
  lazy(() => import("views/pages/authentication/ResetPassword")),
);
const AuthCodeVerification3 = Loadable(
  lazy(() => import("views/pages/authentication/CodeVerification")),
);

// maintenance routing
const MaintenanceError = Loadable(
  lazy(() => import("views/pages/maintenance/Error")),
);
const MaintenanceError500 = Loadable(
  lazy(() => import("views/pages/maintenance/Error500")),
);

// landing & contact-us routing
const PagesLanding = Loadable(lazy(() => import("views/pages/landing")));

// public rally routing
const RallyList = Loadable(lazy(() => import("views/pages/rally-list")));
const RallyNext = Loadable(lazy(() => import("views/pages/rally-next")));
const RallyIframesTest = Loadable(
  lazy(() => import("views/pages/rally-iframes-test")),
);
const BookingForm = Loadable(lazy(() => import("views/pages/booking")));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: "/",
  element: <MinimalLayout />,
  children: [
    {
      path: "/pages/login/login3",
      element: <AuthLogin3 />,
    },
    {
      path: "/pages/register/register3",
      element: <AuthRegister3 />,
    },
    {
      path: "/pages/forgot-password/forgot-password3",
      element: <AuthForgotPassword3 />,
    },
    {
      path: "/pages/check-mail/check-mail3",
      element: <AuthCheckMail3 />,
    },
    {
      path: "/pages/reset-password/reset-password3",
      element: <AuthResetPassword3 />,
    },
    {
      path: "/pages/code-verification/code-verification3",
      element: <AuthCodeVerification3 />,
    },

    {
      path: "/pages/error",
      element: <MaintenanceError />,
    },
    {
      path: "/pages/500",
      element: <MaintenanceError500 />,
    },

    {
      path: "/pages/landing",
      element: <PagesLanding />,
    },
    {
      path: "/rally-list",
      element: <RallyList />,
    },
    {
      path: "/rally-next",
      element: <RallyNext />,
    },
    {
      path: "/test-rally-iframes",
      element: <RallyIframesTest />,
    },
    {
      path: "/book/:rallyId",
      element: <BookingForm />,
    },
  ],
};

export default AuthenticationRoutes;
